import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { APP_URL } from "../request/api";
import { request } from "../request/request";

const initialState = {
    columns: [],
    data: [],
    meta: {},
    loadingStatus: "idle",
    error: null
}

export const fetchExportPreventiveSlice = createAsyncThunk(
    'exportPreventive/fetchExportPreventiveSlice',
    async ({token, params, page}, {rejectWithValue}) => {
        try {
            const customHeaders = {
                Authorization: `Bearer ${token}`
            }

            const response = request(
                `${APP_URL}/surveys/export?${params}&page=${page}`,
                'GET',
                null,
                customHeaders
            )

            return response;
        } catch (error) {
            rejectWithValue(error.status);
        }
    }
)

const exportPreventiveSlice = createSlice({
    name: 'exportPreventive',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchExportPreventiveSlice.pending, (state) => {
                state.columns = [];
                state.data = [];
                state.loadingStatus = "loading";
                state.error = null;
            })
            .addCase(fetchExportPreventiveSlice.fulfilled, (state, action) => {
                state.columns = action.payload.columns;
                state.data = action.payload.data;
                state.meta = action.payload.meta;
                state.loadingStatus = "idle";
                state.error = null;
            })
            .addCase(fetchExportPreventiveSlice.rejected, (state, action) => {
                state.columns = [];
                state.data = [];
                state.loadingStatus = "error";
                state.error = action.payload;
            })
    }
})

export default exportPreventiveSlice.reducer;